import { MenuPickerSubmenuItem } from '../Menu';
import { ALL_BUSINESS_UNIT_ID, BUSINESS_UNIT_URL_PARAM, DEFAULT_BUSINESS_UNIT_ID } from '../../constants/BusinessUnits';
import { getUrlParamValue, removeUrlParams } from '../../utils/urlParamHelpers';
import { usePortal } from '../../hooks/useNavConfig';
import { setLocalStorageBusinessUnitId } from '../../utils/businessUnitsUtils';
import { navigateToUrl } from '../../utils/navigateToUrl';
import getWindow from '../../utils/getWindow';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const BusinessUnitPickerSubmenuItem = ({
  businessUnit
}) => {
  let link;
  const {
    portalId
  } = usePortal();
  const handleClick = () => {
    setLocalStorageBusinessUnitId({
      portalId,
      businessUnit
    });
    if (getUrlParamValue(BUSINESS_UNIT_URL_PARAM)) {
      link = removeUrlParams(BUSINESS_UNIT_URL_PARAM);
      navigateToUrl(link);
    } else {
      getWindow().location.reload();
    }
  };
  const businessUnitDisplayName = businessUnit.id === DEFAULT_BUSINESS_UNIT_ID ? `${businessUnit.name} (Account)` : businessUnit.name;
  const clickAction = businessUnit.id === ALL_BUSINESS_UNIT_ID ? 'All Business Units Selected' : 'Business Unit Selected';
  return /*#__PURE__*/_jsx(MenuPickerSubmenuItem, {
    "data-test-id": "nav-account-menu-business-unit-picker-submenu-item",
    "data-click-action": clickAction,
    onClick: handleClick,
    link: link,
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: businessUnitDisplayName
    })
  });
};
export default BusinessUnitPickerSubmenuItem;